import React from 'react';
import { PageHeader, Page, PageContent, Box, Text } from 'grommet';
import { DashboardGrid } from '../../components/DashboardGrid'; 
import HomeTilesCSV from '../../data/home/HomeTiles.csv';

export const Home = () => {

  return (
    <Page flex="grow" background="background">

      <Box
        background="url('/images/home-banner.png')"
        height={{ min: '140px', max: 'auto' }}
        margin={{ top: 'none' }}
        pad={{ bottom: 'small' }} 
        style={{ backgroundSize: 'cover', backgroundPosition: 'center' }} // Ensuring the background scales correctly
      >
        <Box margin={{ top: 'none', left: 'large' }} pad={{ horizontal: 'small' }}>
          <PageHeader
            pad={{ top: '5px', bottom: '10px' }}
            title={<Text color="black" size="xxlarge" weight="bolder" style={{ fontWeight: 'bold' }}>Welcome to HPE's Internal Explorer</Text>}
            subtitle={'Explore our collective future together... today.'}
            style={{ color: 'black' }}
            size='medium'
          />
          
        </Box>
      </Box>

      <PageContent flex="grow">

          <DashboardGrid filePath={HomeTilesCSV} />

      </PageContent> 

    </Page>
  );
};